export default __webpack_public_path__ + "static/media/profile-pic1.1312dcfc.png";